import VueRouter from "vue-router";
import ProductDetails from "../components/product/ProductDetails";
import Shop from "../components/shop/Shop.vue";
import Login from "../components/auth/Login.vue";
// import Logout from "../components/auth/Logout.vue";
import Register from "../components/auth/Register.vue";
import Profile from "../components/auth/Profile.vue";
import ForgotPassword from "../components/auth/ForgotPassword";
import ResetPassword from "../components/auth/ResetPassword";
import Cart from "../components/cart/Cart";
import Checkout from "../components/checkout/Checkout";
import Thankyou from "../components/checkout/Thankyou";
import NewAddress from "../components/auth/NewAddress";
import EditAddress from "../components/auth/EditAddress";
import Orders from "../components/auth/Orders";
import Order from "../components/auth/Order";
import Prices from "../components/calculatedPrices/Prices";
import Shipping from "../components/calculatedPrices/Shipping";
import NewShipping from "../components/calculatedPrices/NewShipping";
import EditShipping from "../components/calculatedPrices/EditShipping";
import NewFdImm from "../components/fd-imm/NewFdImm";
import FdImm from "../components/fd-imm/FdImm";
import FdImmTable from "../components/fd-imm/FdImmTable";
import EditFdImm from "../components/fd-imm/EditFdImm";
import EditProfile from "../components/auth/EditProfile";
import Excel from "../components/excel/Excel.vue";
import GenericForm from "../components/excel/days/GenericForm";
import GenericOtherTask from "../components/excel/days/GenericOtherTask";
import TasksForm from "../components/excel/days/TasksForm";
import SimilarTasksForm from "../components/excel/days/SimilarTasksForm";
import EmailsForm from "../components/excel/days/EmailsForm";
import UnfinishedTasksForm from "../components/excel/days/UnfinishedTasksForm";
import AmPriorityTasksForm from "../components/excel/days/AmPriorityTasksForm";
import PmPriorityTasksForm from "../components/excel/days/PmPriorityTasksForm";
import EditTaskForm from "../components/excel/days/EditTaskForm";
import EditEmailForm from "../components/excel/days/EditEmailForm";
import EditSimilarTaskForm from "../components/excel/days/EditSimilarTaskForm";
import EditUnfinishedTaskForm from "../components/excel/days/EditUnfinishedTaskForm";
import EditAmPriorityTaskForm from "../components/excel/days/EditAmPriorityTaskForm";
import EditPmPriorityTaskForm from "../components/excel/days/EditPmPriorityTaskForm";
import IssuesForm from "../components/excel/days/IssuesForm";
import PurposesForm from "../components/excel/days/PurposesForm";
import OverLoadForm from "../components/excel/days/OverLoadForm";
import EditIssuesForm from "../components/excel/days/EditIssuesForm";
import EditPurposesForm from "../components/excel/days/EditPurposesForm";
import EditOverLoadForm from "../components/excel/days/EditOverLoadForm";
import EditOverLoadFormTomorrow from "../components/excel/days/EditOverLoadFormTomorrow";
import RatingsForm from "../components/excel/days/RatingsForm";
import EditRatingsForm from "../components/excel/days/EditRatingsForm";
import ChangePassword from "../components/auth/ChangePassword";
import Shops from "../components/shops/Shops";
import ProductShop from "../components/shops/ProductShop";
import ScreenTasks from "../components/excel/days/ScreenTasks";
import MonthlyRatings from "../components/excel/days/MonthlyRatings";
import AddFastTasksForm from "../components/excel/days/AddFastTasksForm";
import EditFastTasksForm from "../components/excel/days/EditFastTasksForm";
import FinishedTasks from "../components/excel/days/FinishedTasks";
import EditComments from "../components/excel/days/EditComments";
import Home from "../components/home/Home";
import WeeklyGenericForm from "../components/excel/days/WeeklyGenericForm";
import EditWeeklyTasks from "../components/excel/days/EditWeeklyTasks";
import FastTasksGeneric from "../components/excel/days/FastTasksGeneric";
import AddWeeklyTask from "../components/excel/days/AddWeeklyTask";
import EditDailyTask from "../components/excel/days/EditDailyTask";
// import Scan from "../components/scan/Scan";
// import ScanTable from "../components/scan/ScanTable";
import Wishlist from "../components/partials/wishlist/Wishlist";
import Impressum from "../components/pages/Impressum";
import Agb from "../components/pages/Agb";
import Daten from "../components/pages/Daten";
import ReturnPolicy from "../components/pages/ReturnPolicy";
import Transport from "../components/pages/Transport";
import KundenService from "../components/pages/KundenService";
import Sichere from "../components/pages/Sichere";
import Versand from "../components/pages/Versand";
import ScanAw from "../components/aw/ScanAw";
import ScanWm from "../components/aw/ScanWm";
import Wm from '../components/aw/Wm';
import GiftCode from '../components/giftcode/GiftCode';
import NotFound from "../components/pages/NotFound";

// import { store } from "../store/store.js";

const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
  },
  {
    path: "/products",
    component: Shop,
    name: "products",
    meta: {
      breadcrumb: "Shop",
    },
    children: [],
  },

  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresVisitor: true,
      breadcrumb: "Login",
    },
  },
  {
    path: "/register",
    component: Register,
    meta: {
      requiresVisitor: true,
      breadcrumb: "Register",
    },
  },
  {
    path: "/password/email",
    component: ForgotPassword,
    meta: {
      breadcrumb: "ForgotPassword",
    },
  },
  {
    path: "/reset-password/:token",
    component: ResetPassword,
    name: "reset-password",
  },
  // {
  //   path: "/logout",
  //   component: Logout,
  // },
  {
    path: "/profile",
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      breadcrumb: "Profile",
    },
  },
  {
    path: "/wishlist",
    component: Wishlist,
    name: "wishlist",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/change-pwd",
    component: ChangePassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-profile/:id",
    component: EditProfile,
    name: "edit-profile",
    meta: {
      requiresAuth: true,
      breadcrumb: "Edit Profile",
    },
  },
  {
    path: "/address/create",
    component: NewAddress,
    name: "create-address",
  },
  {
    path: "/address/:id",
    component: EditAddress,
    name: "address",
  },
  {
    path: "/product/:id",
    component: ProductDetails,
    name: "product",
    meta: {
      breadcrumb: (routeParameters) => `${routeParameters.id}`,
    },
  },
  {
    path: "/cart",
    component: Cart,
    meta: {
      breadcrumb: "Cart",
    },
  },
  {
    path: "/checkout",
    component: Checkout,
    meta: {
      requiresAuth: true,
      breadcrumb: "Checkout",
    },
  },
  {
    path: "/thankyou",
    component: Thankyou,
    name: "thankyou",
  },
  {
    path: "/impressum",
    component: Impressum,
    name: "impressum",
  },
  {
    path: "/agb",
    component: Agb,
    name: "agb",
  },
  {
    path: "/daten",
    component: Daten,
    name: "daten",
  },
  {
    path: "/widerrufsrecht",
    component: ReturnPolicy,
    name: "returnPolicy",
  },
  {
    path: "/transport-gratis",
    component: Transport,
    name: "transport-gratis",
  },
  {
    path: "/kunden",
    component: KundenService,
    name: "kunden",
  },
  {
    path: "/sichere",
    component: Sichere,
    name: "sichere",
  },
  {
    path: "/versand",
    component: Versand,
    name: "versand",
  },
  {
    path: "/orders",
    component: Orders,
    name: "orders",
    meta: {
      breadcrumb: "Orders",
    },
  },
  {
    path: "/order/:order_number",
    component: Order,
    name: "order",
  },
  {
    path: "/shops",
    component: Shops,
    name: "shops",
  },
  {
    path: "/shops/:username",
    component: ProductShop,
    name: "product-shop",
  },
  {
    path: "/calculator",
    component: Prices,
  },
  {
    path: "/shipping",
    component: Shipping,
    name: "shipping",
  },
  {
    path: "/new-shipping",
    component: NewShipping,
    name: "new-shipping",
  },
  {
    path: "/edit-shipping/:id",
    component: EditShipping,
    name: "edit-shipping",
  },
  {
    path: "/fd-imm",
    component: FdImm,
    name: "fd-imm",
  },
  {
    path: "/new-fdimm",
    component: NewFdImm,
    name: "new-fdimm",
  },
  {
    path: "/fd-imm-table",
    component: FdImmTable,
    name: "fd-imm-table",
  },
  {
    path: "/edit-fd-imm/:id",
    component: EditFdImm,
    name: "edit-fd-imm",
  },
  {
    path: "/excel",
    component: Excel,
    name: "excel",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add/task",
    component: GenericForm,
    name: "add-task",
  },
  {
    path: "/add/other",
    component: GenericOtherTask,
    name: "add-other",
  },
  {
    path: "/days/add-task",
    component: TasksForm,
    name: "days-add-task",
  },
  {
    path: "/days/add-email",
    component: EmailsForm,
    name: "days-add-email",
  },
  {
    path: "/days/add-similar-task",
    component: SimilarTasksForm,
    name: "days-add-similar-task",
  },
  {
    path: "/days/add-unfinished-task",
    component: UnfinishedTasksForm,
    name: "days-add-unfinished-task",
  },
  {
    path: "/edit-comment/:id/:user_id",
    component: EditComments,
    name: "edit-comment",
  },
  {
    path: "/days/add-am-priority-task",
    component: AmPriorityTasksForm,
    name: "days-add-am-priority-task",
  },
  {
    path: "/days/add-pm-priority-task",
    component: PmPriorityTasksForm,
    name: "days-add-pm-priority-task",
  },
  {
    path: "/days/edit-task/:id",
    component: EditTaskForm,
    name: "days-edit-task",
  },
  {
    path: "/days/edit-email/:id",
    component: EditEmailForm,
    name: "days-edit-email",
  },
  {
    path: "/days/edit-edit-similar-task/:id",
    component: EditSimilarTaskForm,
    name: "days-edit-similar-task",
  },
  {
    path: "/days/edit-unfinished-task/:id",
    component: EditUnfinishedTaskForm,
    name: "days-edit-unfinished-task",
  },
  {
    path: "/days/edit-am-priority-task/:id",
    component: EditAmPriorityTaskForm,
    name: "days-edit-am-priority-task",
  },
  {
    path: "/days/edit-pm-priority-task/:id",
    component: EditPmPriorityTaskForm,
    name: "days-edit-pm-priority-task",
  },
  {
    path: "/days/add-issue",
    component: IssuesForm,
    name: "add-issue",
  },
  {
    path: "/days/add-purpose",
    component: PurposesForm,
    name: "add-purposeS",
  },
  {
    path: "/days/add-overLoad",
    component: OverLoadForm,
    name: "add-overLoad",
  },
  {
    path: "/days/edit-issue/:id",
    component: EditIssuesForm,
    name: "edit-issue",
  },
  {
    path: "/days/editpurpose/:id",
    component: EditPurposesForm,
    name: "edit-purpose",
  },
  {
    path: "/days/edit-overload/:id",
    component: EditOverLoadForm,
    name: "edit-overload",
  },
  {
    path: "/days/edit-overload-tomorrow/:id",
    component: EditOverLoadFormTomorrow,
    name: "edit-overload-tomorrow",
  },
  {
    path: "/days/add-ratings",
    component: RatingsForm,
    name: "add-ratings",
    props: true,
  },
  {
    path: "/days/edit-ratings/:id",
    component: EditRatingsForm,
    name: "edit-ratings",
  },
  {
    path: "/screen-tasks",
    component: ScreenTasks,
    name: "screen-tasks",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/monthly-ratings",
    component: MonthlyRatings,
    name: "monthly-ratings",
  },
  {
    path: "/add-fast-task",
    component: AddFastTasksForm,
    name: "add-fast-task",
  },
  {
    path: "/edit-fast-task/:id",
    component: EditFastTasksForm,
    name: "edit-fast-task",
  },
  {
    path: "/weekly-tasks",
    component: WeeklyGenericForm,
    name: "weekly-tasks",
  },
  {
    path: "/add-weekly-tasks",
    component: AddWeeklyTask,
    name: "add-weekly-tasks",
  },
  {
    path: "/edit-weekly-task/:id",
    component: EditWeeklyTasks,
    name: "edit-weekly-tasks",
  },
  {
    path: "/fast-tasks",
    component: FastTasksGeneric,
    name: "fast-tasks",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finished-tasks",
    component: FinishedTasks,
    name: "finished-tasks",
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/edit-daily-task/:id",
    component: EditDailyTask,
    name: "edit-daily-tasks",
  },
  // {
  //   path: "/scan",
  //   component: Scan,
  //   name: "scan",
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: "/scan-table/:name",
  //   component: ScanTable,
  //   name: "scan-table",
  // },
  {
    path: "/scan-aw",
    name: "scan-aw",
    component: ScanAw,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/scan-wm',
    name: 'scan-wm',
    component: Wm,
    meta: {
      requiresAuth: true
    }
  },

  // SCAN AW ME KTHY NESE DEL GABIM
  // {
  //   path: "/wm/:tr_idtrans",
  //   name: "wm",
  //   component: ScanWm,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },


  // KTO TJETREN ME FSHI
  {
      path: "/wm/:tr_idtrans/:is_grabowski",
      name: "wm",
      component: ScanWm,
      meta: {
        requiresAuth: true,
      },
    },

  {
    path: "/gift_code",
    component: GiftCode,
    meta: {
      requiresAuth: true,
    },
    name: "GiftCode",
  },
  {
    path: "/*",
    component: NotFound,
    name: "404",
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
});

export default router;
